module.exports = __webpack_public_path__ + "static/media/icon-passport-main.4686842c.svg";